import { TEST_TIME_LIMIT_MINUTES, TEST_PRICE_INR, TEST_MRP_INR } from '../../constants/app';

type Variant = 'pills' | 'inline' | 'compact';

interface TestQuickFactsProps {
  variant?: Variant;
  className?: string;
  showQuestions?: boolean;
  showDomains?: boolean;
  showPrice?: boolean;
}

export function TestDurationText({ className = '' }: { className?: string }) {
  return (
    <span className={className}>
      {TEST_TIME_LIMIT_MINUTES} Minutes
    </span>
  );
}

/** Selling price with the MRP struck through: ₹499 ₹199 */
export function TestReportPrice({ className = '' }: { className?: string }) {
  return (
    <span className={className}>
      <span className="line-through opacity-60 font-normal mr-1.5">₹{TEST_MRP_INR}</span>
      <span>₹{TEST_PRICE_INR}</span>
    </span>
  );
}

export default function TestQuickFacts({
  variant = 'pills',
  className = '',
  showQuestions = true,
  showDomains = false,
  showPrice = false,
}: TestQuickFactsProps) {
  const items = [
    { icon: 'ri-time-line', label: `${TEST_TIME_LIMIT_MINUTES} Minutes` },
    ...(showQuestions ? [{ icon: 'ri-question-line', label: '60 Questions' }] : []),
    ...(showDomains ? [{ icon: 'ri-brain-line', label: '7 Domains' }] : []),
    ...(showPrice ? [{ icon: 'ri-price-tag-3-line', label: `Report ₹${TEST_PRICE_INR} (MRP ₹${TEST_MRP_INR})`, strike: `₹${TEST_MRP_INR}`, main: `Report ₹${TEST_PRICE_INR}` }] : []),
  ];

  if (variant === 'inline') {
    return (
      <p className={`text-gray-600 ${className}`}>
        {items.map((item) => item.label).join(' · ')}
      </p>
    );
  }

  if (variant === 'compact') {
    return (
      <span className={`text-sm font-semibold text-gray-700 ${className}`}>
        {TEST_TIME_LIMIT_MINUTES} min
      </span>
    );
  }

  return (
    <div className={`flex flex-wrap justify-center lg:justify-start gap-3 ${className}`}>
      {items.map((item) => (
        <div
          key={item.label}
          className="flex items-center bg-white/60 backdrop-blur-sm px-4 py-2 rounded-full"
        >
          <i className={`${item.icon} w-5 h-5 flex items-center justify-center text-blue-600 mr-2`}></i>
          <span className="font-semibold text-gray-700">
            {'strike' in item ? (
              <>
                <span className="line-through opacity-60 font-normal mr-1.5">{item.strike}</span>
                {item.main}
              </>
            ) : item.label}
          </span>
        </div>
      ))}
    </div>
  );
}
